import { buildPeriod, dayjs, getPeriodDaysWithUtc, groupBy } from '@weft/utils';
import type { Dayjs } from '@weft/utils';

export function getMonthlyEventsGroupKey(date: Dayjs, eventsPerMonth: number) {
  const monthInYear = date.format('MMM YY');
  const eventsPerMonthIndex = getDateIndexInChunkedMonth(date, eventsPerMonth);

  return `${monthInYear}-${eventsPerMonthIndex}`;
}

function getDateIndexInChunkedMonth(date: Dayjs, chunksPerMonth: number) {
  const daysInMonth = date.daysInMonth();
  const daysInChunk = Math.ceil(daysInMonth / chunksPerMonth);
  const dayInMonth = Number(date.format('DD'));
  const dayInMonthChunkIndex = Math.floor(dayInMonth / daysInChunk);

  return Math.min(dayInMonthChunkIndex, chunksPerMonth - 1);
}

export function getCurrentMonthChunkDates(date: Date, eventsPerMonth: number) {
  const startOfMonth = dayjs(date).startOf('month');
  const endOfMonth = dayjs(date).endOf('month');
  const monthPeriod = buildPeriod(startOfMonth.toDate(), endOfMonth.toDate());
  const datesInMonth = getPeriodDaysWithUtc(monthPeriod, true);

  const inputDateMonthIndex = getDateIndexInChunkedMonth(dayjs(date), eventsPerMonth);

  const datesInMonthByMonthIndex = groupBy(datesInMonth, (dateInMonth) => getDateIndexInChunkedMonth(dateInMonth, eventsPerMonth));
  const currentMonthChunk = datesInMonthByMonthIndex.get(inputDateMonthIndex);

  return currentMonthChunk ?? [];
}